import React, {useRef, useState} from 'react';
import {Modal} from "../../../../components/modal/modal.jsx";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {AgGridReact} from "ag-grid-react";
import {useQuery} from "@tanstack/react-query";
import userMessagesService from "../../../../services/web/user-messages-service.js";
import UserMessagesReceiverStatusCell from "./user-messages-receiver-status-cell.jsx";
import Button from "../../../../components/button/button.jsx";

const UserMessagesReceiver = ({open, setOpen, message}) => {
    const {data} = useQuery({
        queryFn: () => userMessagesService.getUsersReceiverByMessageId(message?.id),
        queryKey: ["usersReceiver", {open, id: message.id}],
        enabled: open
    })

    const gridRef = useRef(undefined);

    const [columnDefs,] = useState([
        {
            headerName: "Nome",
            field: "name",
            sort: "asc",
            flex: 1,
            valueFormatter: ({data}) => data.name + (data.namewar ? " (" + data.namewar + ")" : "")
        },
        {headerName: "Status", field: "status", width: 100, cellRenderer: UserMessagesReceiverStatusCell}
    ]);

    return (
        <Modal open={open} setOpen={setOpen} title={message?.title}>
            <Modal.Body>
                <div style={{height: "calc(100vh - 237px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={data ?? []}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default UserMessagesReceiver;